export const buttonValue = [
  { name: "Our Mission", value: "mission" },
  { name: "Our Vision", value: "vision" },
  { name: "Our Value", value: "value" },
];

export const missionOption = [
  { option: "Creamy texture and healthy fats." },
  { option: "Crisp and refreshing for added crunch." },
  { option: "High-quality oil for a rich dressing." },
];

export const visionOption = [
  { option: "Aromatic and fragrant, enhances flavor." },
  { option: "Aged for depth and richness." },
  { option: "Enhances all the natural flavors." },
];
export const valueOption = [
  { option: "Natural sweetness with a hint of caramel." },
  { option: "Rich and aromatic for enhanced flavor." },
  { option: "High-quality eggs for moisture and structure." },
];
